import { useUpdate } from '@lib/systems/update'
import { randomRange } from '@lib/util/random'
import { useParallax } from '@game/systems/parallax'
import { useWind } from '@game/systems/wind'

const { direction: wind } = useWind()

class Particles {
  constructor () {
    this.particles = []
  }

  clear () {
    for (const key in this.particles) {
      delete this.particles[key]
    }
  }

  update () {
    let particle, dx, dy
    for (let i = 0; i < this.particles.length; i++) {
      particle = this.particles[i]

      // Wind
      dx = wind.x * Math.random()
      dy = wind.y * Math.random()
      particle.velx += dx
      particle.vely += dy

      // Position
      particle.x += particle.velx
      particle.y += particle.vely
      particle.velx *= 0.925
      particle.vely *= 0.925

      // Size
      particle.radius = Math.round(particle.radius * (1 - (particle.life / particle.maxLife)))

      // Life
      particle.life++
      if (particle.life >= particle.maxLife) this.particles.splice(i, 1)
    }
  }

  draw (render) {
    let particle
    for (let i = 0; i < this.particles.length; i++) {
      particle = this.particles[i]
      render('particle', particle.x, particle.y, particle.z, particle.radius, particle.color, null, particle.z)
    }
  }

  emit (amt, x, y, colors, opts = {}) {
    const {
      velx = 0,
      vely = 0,
      life: maxLife = -1
    } = opts

    if (Array.isArray(amt)) {
      amt = randomRange(amt[0], amt[1])
    }

    let radius
    for (let i = 0; i < amt; i++) {
      radius = 1 + Math.round(Math.random() * 2)
      this.particles.push({
        x,
        y,
        z: Math.round(Math.random() * 5),
        velx: velx * (Math.random() > 0.5 ? 0.5 : -0.5),
        vely: vely * (Math.random() > 0.5 ? 0.5 : -0.5),
        life: 0,
        maxLife: maxLife === -1 ? randomRange(200, 1000) : maxLife,
        maxRadius: radius,
        radius: radius,
        color: (Array.isArray(colors))
          ? colors[Math.round(Math.random() * (colors.length - 1))]
          : colors
      })
      if (this.particles.length > 100) this.particles.shift()
    }
  }
}

const particles = new Particles()

export function enableParticles () {
  useUpdate(function () {
    particles.update()
  }, {
    updateOrder: 100
  })

  useParallax(function (render) {
    particles.draw(render)
  }, {
    drawOrder: 200
  })
}

export function useParticles () {
  return {
    clear: particles.clear.bind(particles),
    draw: particles.draw.bind(particles),
    emit: particles.emit.bind(particles)
  }
}
